import React from 'react';
import { Link } from 'gatsby';
import Img from './img-wrapper';
import Breadcrumb from './breadcrumb';

const AmbitiInterventoPageTemplate = ({ title, intro, titleDisturbi, disturbi }) => {
  const breadcrumb = [
    {
      link: '/chi-sono/',
      name: 'Chi sono'
    },
    { name: title }
  ];
  return (
    <>
      <div className="section mt-0">
        <div className="container-xl">
          <div className="row mb-3">
            <div className="col-12">
              <Breadcrumb breadcrumb={breadcrumb} />
            </div>
          </div>
          <div className="row">
            <div className="col">
              <h1>{title}</h1>
            </div>
          </div>
          <div className="row">
            <div className="col-12" dangerouslySetInnerHTML={{ __html: intro }}></div>
          </div>
        </div>
      </div>
      <div className="section mt-0">
        <div className="container-xl">
          <div className="row">
            <div className="col-12">
              <h2>{titleDisturbi}</h2>
            </div>
          </div>
          <div className="row">
            {disturbi
              ? disturbi.map((item, i) => (
                  <div className="col-lg-6 mb-5" key={i}>
                    <div className="row">
                      <div className="col-12">
                        <h3>{item.title}</h3>
                        <Img image={item.image} className="disturbo__prev-img" alt="" />
                        <div
                          className="section__text-small mt-3"
                          dangerouslySetInnerHTML={{ __html: item.abstract }}
                        ></div>
                        <Link to={`/${item.slug}/`} className="d-inline-block">
                          Leggi di più
                        </Link>
                      </div>
                    </div>
                  </div>
                ))
              : null}
          </div>
        </div>
      </div>
    </>
  );
};

export default AmbitiInterventoPageTemplate;
